import type { TRouteParams } from './definitions'

import ClientRouter from '@common/Router/ClientRouter'

import { ERoute } from './definitions'

import renderProduct from './scripts/utils/renderProduct'

const router = new ClientRouter()

const main      = document.body.querySelector<HTMLElement>('#main')
const gtc       = document.body.querySelector<HTMLElement>('#gtc')
const dmi       = document.body.querySelector<HTMLElement>('#dmi')
const impressum = document.body.querySelector<HTMLElement>('#impressum')
const product   = document.body.querySelector<HTMLElement>('#product')
const notFound  = document.body.querySelector<HTMLElement>('#notFound')

router.addRoute(ERoute.Main, async () => {
  await import(
    /* webpackChunkName: "MainPage" */
    './pages/MainPage'
  )

  if (main) {
    main.style.display = 'block'
  }

  if (gtc) {
    gtc.style.display = 'none'
  }

  if (dmi) {
    dmi.style.display = 'none'
  }

  if (impressum) {
    impressum.style.display = 'none'
  }

  if (product) {
    product.style.display = 'none'
  }

  if (notFound) {
    notFound.style.display = 'none'
  }
})

router.addRoute(ERoute.Gtc, async () => {
  await import(
    /* webpackChunkName: "GtcPage" */
    './pages/GtcPage'
  )

  if (main) {
    main.style.display = 'none'
  }

  if (gtc) {
    gtc.style.display = 'block'
  }

  if (dmi) {
    dmi.style.display = 'none'
  }

  if (impressum) {
    impressum.style.display = 'none'
  }

  if (product) {
    product.style.display = 'none'
  }

  if (notFound) {
    notFound.style.display = 'none'
  }
})

router.addRoute(ERoute.DataManagementInformation, async () => {
  await import(
    /* webpackChunkName: "DmiPage" */
    './pages/DmiPage'
  )

  if (main) {
    main.style.display = 'none'
  }

  if (gtc) {
    gtc.style.display = 'none'
  }

  if (dmi) {
    dmi.style.display = 'block'
  }

  if (impressum) {
    impressum.style.display = 'none'
  }

  if (product) {
    product.style.display = 'none'
  }

  if (notFound) {
    notFound.style.display = 'none'
  }
})

router.addRoute(ERoute.Impressum, async () => {
  await import(
    /* webpackChunkName: "ImpressumPage" */
    './pages/ImpressumPage'
  )

  if (main) {
    main.style.display = 'none'
  }

  if (gtc) {
    gtc.style.display = 'none'
  }

  if (dmi) {
    dmi.style.display = 'none'
  }

  if (impressum) {
    impressum.style.display = 'block'
  }

  if (product) {
    product.style.display = 'none'
  }

  if (notFound) {
    notFound.style.display = 'none'
  }
})

router.addRoute(ERoute.Product, async (params: TRouteParams) => {
  await import(
    /* webpackChunkName: "ProductPage" */
    './pages/ProductPage'
  )

  if (main) {
    main.style.display = 'none'
  }

  if (gtc) {
    gtc.style.display = 'none'
  }

  if (dmi) {
    dmi.style.display = 'none'
  }

  if (impressum) {
    impressum.style.display = 'none'
  }

  if (product) {
    product.style.display = 'block'
  }

  if (notFound) {
    notFound.style.display = 'none'
  }

  const sku = `${ params?.sku ?? '' }`

  await renderProduct(sku)
})

router.setNotFound(async () => {
  await import(
    /* webpackChunkName: "NotFoundPage" */
    './pages/NotFoundPage'
  )

  if (main) {
    main.style.display = 'none'
  }

  if (gtc) {
    gtc.style.display = 'none'
  }

  if (dmi) {
    dmi.style.display = 'none'
  }

  if (impressum) {
    impressum.style.display = 'none'
  }

  if (product) {
    product.style.display = 'none'
  }

  if (notFound) {
    notFound.style.display = 'block'
  }
})

router.listen()

export default router
